import air from "../icons/air.svg";
import earth from "../icons/earth.svg";
import fire from "../icons/fire.svg";
import water from "../icons/water.svg";
const monsters = {
  monster: [
    {
      name: "charizard",
      attack: 15,
      defense: 10,
      elemental: fire,
    },
    {
      name: "charizard5",
      attack: 34,
      defense: 10,
      elemental: water,
    },
    {
      name: "charizard4",
      attack: 15,
      defense: 10,
      elemental: air,
    },
    {
      name: "charizard46",
      attack: 15,
      defense: 10,
      elemental: earth,
    },
  ],
};
export default monsters;
